import XhrRequestHandler from '../../lib/XhrRequestHandler';

export interface ActivityEnhancementOptionsPayload {
  /* required */
  activity_name: string;
  project_code: string;
  project_name: string;
  /* optional */
  company_name?: string;
  company_country?: string;
  activity_description: string;
}
export interface EnhancedActivity {
  activity_name: string;
  activity_description: string;
}

export class AiActivityEnhancementSystem {
  private readonly base = '/prompt/activity-complete';

  constructor(private requestHandler: XhrRequestHandler) {}

  async enhanceActivity(payload: ActivityEnhancementOptionsPayload): Promise<EnhancedActivity> {
    return this.requestHandler.post<EnhancedActivity>(`${this.base}`, payload);
  }
}
